import type { SVGProps } from 'react';
const SvgChevronArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.652 17.724a.9.9 0 0 1 .025-1.273L13.402 12 8.677 7.549A.9.9 0 0 1 9.924 6.25l5.4 5.1a.9.9 0 0 1 0 1.298l-5.4 5.1a.9.9 0 0 1-1.272-.025"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronArrowRight;
